module.exports = __webpack_public_path__ + "static/media/logo-dark.5ad797fa.png";